import React, { useEffect, useState } from 'react';
import DeleteButton from '../../../../components/UI/Buttons/DeleteButton';
import classes from './ExceptionalOpening.module.css';
import ExceptionalOpeningModal from '../../Modals/ExceptionalOpening/ExceptionalOpeningModal';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectCalendarAndSlots,
  updateCalendarAndSlotsState,
} from '../../../../store/slices/calendarAndSlots';

import EditButton from '../../../../components/UI/Buttons/EditButton';
import { useTranslation } from '../../../../hooks/useTranslations';

type Props = {
  isModalOpen: boolean;
  onModalClose: () => void;
  setOpeningHoursModal: (value: number) => void;
};

const ExceptionalOpening: React.FC<Props> = ({
  isModalOpen,
  onModalClose,
  setOpeningHoursModal,
}) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  const [selectedItem, setSelectedItem] = useState('');
  const [indexOfList, setIndexOfList] = useState<number>();

  let calendarData: any = Array(calendarAndSlots);
  const ExceptionalSlots = calendarAndSlots.exceptional_openings;

  const lang = localStorage.getItem('lang') || 'en';


  const handleDelete = async (item: any) => {
    const found = ExceptionalSlots.find((e: any) => e == item);
    const filteredData = [...ExceptionalSlots].filter((item) => item !== found);
    let dataToPost = [
      {
        ...calendarData[0],
        exceptional_openings: filteredData,
      },
    ];
    dispatch(updateCalendarAndSlotsState(dataToPost[0]));
  };
  const onEditClick = (item: any, index: number | undefined) => {
    setSelectedItem(item);
    setIndexOfList(index);
    setOpeningHoursModal(3);
  };
  useEffect(() => {
    if (!isModalOpen) {
      setSelectedItem('');
    }
  }, [isModalOpen]);
  return (
    <>
      <div className={classes.container}>
        <div className={classes.mainContainer}>
          <text className={classes.headerText}>{translations('day')}</text>
          <text className={classes.headerText}>{translations('from')}</text>
          <text className={classes.headerText}>{translations('to')}</text>
        </div>
        {ExceptionalSlots.map((item: any, index: any) => (
          <div key={index} className={classes.flatlistContainer}>
            <div className={classes.textContainer}>
              <text className={classes.text}>
                {moment(item.opening_date).locale(lang).format('DD.MM.YYYY ; dddd')}
              </text>
            </div>
            <div className={classes.textContainer}>
              <text className={classes.text}>{item.start_time}</text>
            </div>
            <div className={classes.textContainer}>
              <text className={classes.text}>{item.end_time}</text>
            </div>
            <div className={classes.button}>
              <EditButton onClick={() => onEditClick(item, index)} />
            </div>
            <div className={classes.button}>
              <DeleteButton onClick={() => handleDelete(item)} />
            </div>
          </div>
        ))}
      </div>
      <ExceptionalOpeningModal
        isOpen={isModalOpen}
        item={selectedItem}
        index={indexOfList}
        onClose={onModalClose}
      />
    </>
  );
};

export default ExceptionalOpening;
